import React from "react";
import { Link } from "react-router-dom";
import "../css/footer.scss";
import { siteConfig } from "../Datas/productData";

const serviceLinks = [
  ["Contact", "/contact"],
  ["Shipping", "/shipping"],
  ["Returns & exchanges", "/returns"],
  ["Size assistance", "/contact"],
];

const companyLinks = [
  ["About", "/about"],
  ["Shop all", "/shop"],
  ["Privacy policy", "/privacy"],
  ["Cookie policy", "/cookies"],
  ["FAQs", "/faqs"],
  ["Terms", "/terms"],
];

function Footer() {
  const scrollTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  return (
    <footer className="site-footer" role="contentinfo">
      <div className="footer-usps" aria-label="Shopping benefits">
        <Link to="/shipping" onClick={scrollTop}>
          <span>01</span>
          <strong>Complimentary shipping from €150</strong>
        </Link>
        <Link to="/shipping" onClick={scrollTop}>
          <span>02</span>
          <strong>Fast and secure global delivery</strong>
        </Link>
        <Link to="/returns" onClick={scrollTop}>
          <span>03</span>
          <strong>Easy 30-day returns & exchanges</strong>
        </Link>
      </div>

      <div className="footer-main">
        <div className="footer-links">
          <section>
            <h3>Need assistance?</h3>
            {serviceLinks.map(([label, path]) => (
              <Link key={label} to={path} onClick={scrollTop}>
                {label}
              </Link>
            ))}
          </section>
          <section>
            <h3>The company</h3>
            {companyLinks.map(([label, path]) => (
              <Link key={label} to={path} onClick={scrollTop}>
                {label}
              </Link>
            ))}
          </section>
          <section>
            <h3>Information</h3>
            <Link to="/faqs" onClick={scrollTop}>
              Frequently asked questions
            </Link>
            <Link to="/cookies" onClick={scrollTop}>
              Cookie preferences
            </Link>
            <Link to="/terms" onClick={scrollTop}>
              Terms &amp; conditions
            </Link>
          </section>
          <section className="footer-locale">
            <h3>Location & currency</h3>
            <a href={`mailto:${siteConfig.contact.email}`}>
              {siteConfig.contact.email}
            </a>
            <p>
              {siteConfig.legalName}
              <br />
              {siteConfig.contact.address}
            </p>
          </section>
        </div>

        <div className="footer-bottom">
          <Link
            className="footer-wordmark"
            to="/"
            onClick={scrollTop}
            aria-label={`${siteConfig.brandName} home`}
          >
            <img src="/wordmark.svg" alt="" />
          </Link>
          <p>
            © {new Date().getFullYear()} {siteConfig.legalName}. All rights
            reserved.
          </p>
          <button type="button" onClick={scrollTop}>
            BACK TO TOP ↑
          </button>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
